import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_68961841 from 'nuxt_plugin_plugin_68961841' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_vlazyload_563686f6 from 'nuxt_plugin_vlazyload_563686f6' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_index_aa3e46d2 from 'nuxt_plugin_index_aa3e46d2' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_gtm_84bc2526 from 'nuxt_plugin_gtm_84bc2526' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_moment_e21560be from 'nuxt_plugin_moment_e21560be' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_6a5cee7f from 'nuxt_plugin_cookieuniversalnuxt_6a5cee7f' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_workbox_0abe7833 from 'nuxt_plugin_workbox_0abe7833' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_687c4774 from 'nuxt_plugin_metaplugin_687c4774' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_3df1dcd7 from 'nuxt_plugin_axios_3df1dcd7' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_fontawesome_79ae72d9 from 'nuxt_plugin_fontawesome_79ae72d9' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_tailwind_87df852e from 'nuxt_plugin_tailwind_87df852e' // Source: ../plugins/tailwind.js (mode: 'all')
import nuxt_plugin_vuetour_f3e3d3bc from 'nuxt_plugin_vuetour_f3e3d3bc' // Source: ../plugins/vue-tour.js (mode: 'all')
import nuxt_plugin_vue3html2pdf_774eff56 from 'nuxt_plugin_vue3html2pdf_774eff56' // Source: ../plugins/vue3-html2pdf (mode: 'client')
import nuxt_plugin_vcalendar_4dbed36c from 'nuxt_plugin_vcalendar_4dbed36c' // Source: ../plugins/v-calendar.js (mode: 'client')
import nuxt_plugin_jwvuepagination_2d2c17e8 from 'nuxt_plugin_jwvuepagination_2d2c17e8' // Source: ../plugins/jw-vue-pagination.js (mode: 'client')
import nuxt_plugin_vuejsontocsv_2728078a from 'nuxt_plugin_vuejsontocsv_2728078a' // Source: ../plugins/vue-json-to-csv.js (mode: 'client')
import nuxt_plugin_auth_8931550e from 'nuxt_plugin_auth_8931550e' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - Summit Professional Education","title":"Summit Professional Education","description":"National leader of continuing education for therapists. In-person, live streaming, live webinars, online videos, and online text courses offering CEUs for PTs, OTs, and SLPs.","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"og:title","name":"og:title","content":"Summit Professional Education"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fd2vu1vyohnm3g3.cloudfront.net\u002Fimages\u002Ffavicon.ico"},{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fd2vu1vyohnm3g3.cloudfront.net\u002Fimages\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Lato:wght@400;900&display=swap"}],"script":[{"src":"\u002Fjs\u002Fkaltura.js"},{"type":"text\u002Fjavascript","innerHTML":"!function(w, d, t) {\n  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\",\"holdConsent\",\"revokeConsent\",\"grantConsent\"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i\u003Cttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(\nvar e=ttq._i[t]||[],n=0;n\u003Cttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r=\"https:\u002F\u002Fanalytics.tiktok.com\u002Fi18n\u002Fpixel\u002Fevents.js\",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement(\"script\")\n;n.type=\"text\u002Fjavascript\",n.async=!0,n.src=r+\"?sdkid=\"+e+\"&lib=\"+t;e=document.getElementsByTagName(\"script\")[0];e.parentNode.insertBefore(n,e)};\n\n\n  ttq.load('CQL5RQ3C77U08RGLVDRG');\n  ttq.page();\n}(window, document, 'ttq');"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5DW76H')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5DW76H&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_68961841 === 'function') {
    await nuxt_plugin_plugin_68961841(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_563686f6 === 'function') {
    await nuxt_plugin_vlazyload_563686f6(app.context, inject)
  }

  if (typeof nuxt_plugin_index_aa3e46d2 === 'function') {
    await nuxt_plugin_index_aa3e46d2(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_84bc2526 === 'function') {
    await nuxt_plugin_gtm_84bc2526(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_e21560be === 'function') {
    await nuxt_plugin_moment_e21560be(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_6a5cee7f === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_6a5cee7f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_0abe7833 === 'function') {
    await nuxt_plugin_workbox_0abe7833(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_687c4774 === 'function') {
    await nuxt_plugin_metaplugin_687c4774(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3df1dcd7 === 'function') {
    await nuxt_plugin_axios_3df1dcd7(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_79ae72d9 === 'function') {
    await nuxt_plugin_fontawesome_79ae72d9(app.context, inject)
  }

  if (typeof nuxt_plugin_tailwind_87df852e === 'function') {
    await nuxt_plugin_tailwind_87df852e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetour_f3e3d3bc === 'function') {
    await nuxt_plugin_vuetour_f3e3d3bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue3html2pdf_774eff56 === 'function') {
    await nuxt_plugin_vue3html2pdf_774eff56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_4dbed36c === 'function') {
    await nuxt_plugin_vcalendar_4dbed36c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_jwvuepagination_2d2c17e8 === 'function') {
    await nuxt_plugin_jwvuepagination_2d2c17e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsontocsv_2728078a === 'function') {
    await nuxt_plugin_vuejsontocsv_2728078a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_8931550e === 'function') {
    await nuxt_plugin_auth_8931550e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
